/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://qvhu0khqdh.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        },
        {
            "name": "commandApi",
            "endpoint": "https://qsu5g7luuj.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        },
        {
            "name": "stripeWebhook",
            "endpoint": "https://jmhwelat66.execute-api.ap-northeast-1.amazonaws.com/prod",
            "region": "ap-northeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://onbw72a7lvcahmlfxxsdmfyhfa.appsync-api.ap-northeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-northeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-yexebzpa4bestbzgu7wtpi5z4q",
    "aws_cognito_identity_pool_id": "ap-northeast-1:c529de09-6a7b-40d3-a5d2-2aac2e94b85a",
    "aws_cognito_region": "ap-northeast-1",
    "aws_user_pools_id": "ap-northeast-1_isFyVdETw",
    "aws_user_pools_web_client_id": "1dai7apnibarq2561usbvi47ja",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "badesk-storage215108-prod",
    "aws_user_files_s3_bucket_region": "ap-northeast-1",
    "aws_appsync_apiTimeout:": "90000"
};


export default awsmobile;
